export function downloadFile(
  file: Blob,
  fileName: string,
  openInNewTab: boolean = false
) {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;

  if (openInNewTab) {
    a.target = "_blank";
  } else {
    a.download = fileName;
  }

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function getFileNameFromHeaders(headers: Headers): string | null {
  const contentDisposition = headers.get("Content-Disposition");

  if (!contentDisposition) {
    return null;
  }

  const filenameMatch = contentDisposition.match(/filename=([^;]+)/);
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1].trim();
  }

  return null;
}
